import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { InquiryConversation } from "../components/InquiryConversation";

export default function BuyerInquiries() {
  const [inquiries, setInquiries] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const r = await api.get("/buyer/inquiries");
    setInquiries(r.data);
    setLoading(false);
  }, []);

  useEffect(() => { load(); }, [load]);

  const totalUnread = inquiries.reduce((s, i) => s + (i.unread || 0), 0);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="border-b border-foreground bg-foreground text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 flex items-center justify-between">
          <div>
            <span className="label-caps text-accent">My activity</span>
            <h1 className="font-display font-black text-3xl tracking-tight mt-1">My conversations</h1>
          </div>
          {totalUnread > 0 && (
            <div className="text-right" data-testid="buyer-unread-total">
              <div className="font-display font-black text-3xl text-accent">{totalUnread}</div>
              <div className="label-caps text-white/60">unread replies</div>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8">
        {loading ? (
          <div className="space-y-2">{Array.from({ length: 3 }).map((_, i) => <div key={i} className="h-20 bg-muted animate-pulse border border-border" />)}</div>
        ) : inquiries.length === 0 ? (
          <div className="border border-dashed border-border p-16 text-center" data-testid="empty-inquiries">
            <p className="font-display font-bold text-xl">No inquiries yet</p>
            <p className="text-sm text-muted-foreground mt-2 mb-6">Browse the marketplace and reach out to sellers.</p>
            <Link to="/marketplace"><Button className="rounded-none bg-primary hover:bg-primary/90">Browse products</Button></Link>
          </div>
        ) : (
          <div className="border border-border divide-y divide-border">
            {inquiries.map((inq) => (
              <div key={inq.inquiry_id} className="p-4" data-testid={`my-inquiry-${inq.inquiry_id}`}>
                <InquiryConversation
                  inquiry={inq}
                  viewerRole="buyer"
                  onChange={load}
                  subtitle={`Seller: ${inq.seller_name || "—"} · started ${new Date(inq.created_at).toLocaleString()}`}
                />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
